// iter148 — Cross-page auto-refresh for Vendors & Cook-cum-Helpers (CCH).
//
// Same pattern as `dailyEntriesBus`: any page that consumes vendors/CCHs
// (Hand Receipts inside Generator, Reports Hub Hand-Receipt tool, MDCF
// Fund Utilization, etc.) subscribes via `useMasterDataVersion()` and
// re-fetches whenever admin/school saves through the Setup UI or the
// public setup form.
//
// Cross-tab sync via the `storage` event; same-tab live sync via the
// in-module listener set.

import { useEffect, useState } from "react";

const KEY_V = "vendors-version";
const KEY_C = "cchs-version";
let _v = Number(sessionStorage.getItem(KEY_V) || 0);
let _c = Number(sessionStorage.getItem(KEY_C) || 0);
const _listeners = new Set();

function _notify() { _listeners.forEach((fn) => fn({ vendorsV: _v, cchsV: _c })); }

export function bumpVendors() {
  _v += 1;
  try {
    localStorage.setItem(KEY_V, String(_v));
    sessionStorage.setItem(KEY_V, String(_v));
  } catch (_e) { /* private mode */ }
  _notify();
}

export function bumpCchs() {
  _c += 1;
  try {
    localStorage.setItem(KEY_C, String(_c));
    sessionStorage.setItem(KEY_C, String(_c));
  } catch (_e) { /* private mode */ }
  _notify();
}

/** Live-updating counter — consumers refetch when it changes. */
export function useMasterDataVersion() {
  const [state, setState] = useState({ vendorsV: _v, cchsV: _c });
  useEffect(() => {
    const fn = (next) => setState(next);
    _listeners.add(fn);
    const onStorage = (ev) => {
      if (ev.key === KEY_V) {
        const n = Number(ev.newValue || 0);
        if (Number.isFinite(n) && n > _v) { _v = n; _notify(); }
      } else if (ev.key === KEY_C) {
        const n = Number(ev.newValue || 0);
        if (Number.isFinite(n) && n > _c) { _c = n; _notify(); }
      }
    };
    window.addEventListener("storage", onStorage);
    const onFocus = () => setState((s) => ({ ...s }));
    window.addEventListener("focus", onFocus);
    return () => {
      _listeners.delete(fn);
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("focus", onFocus);
    };
  }, []);
  return state;
}
